// Persistencia del lector seleccionado, independiente por modo de entrada
// (cámara vs. lector USB vs. manual) — un mismo dispositivo puede tener
// pestañas abiertas de varios modos sin que se pisen entre sí.
const STORAGE_KEYS = {
  camera: 'qr-scanner-id',
  usb: 'qr-scanner-id-usb',
  manual: 'qr-scanner-id-manual',
};

export const loadSavedScannerId = (inputMode) => {
  try { return localStorage.getItem(STORAGE_KEYS[inputMode]) || null; } catch { return null; }
};

export const saveScannerId = (inputMode, id) => {
  try { localStorage.setItem(STORAGE_KEYS[inputMode], id); } catch {}
};

export const clearScannerId = (inputMode) => {
  try { localStorage.removeItem(STORAGE_KEYS[inputMode]); } catch {}
};

// Estado (expandido/minimizado) del panel lateral de historial — persistido
// para que el operador no tenga que volver a colapsarlo en cada carga si así
// prefiere trabajar con más espacio para la cámara/lector.
const HISTORY_PANEL_KEY = 'qr-scanner-history-collapsed';

// null = todavía no hay preferencia explícita guardada (el operador nunca
// tocó el botón de colapsar/expandir en este dispositivo) — distinto de
// `false` (guardó explícitamente "expandido"). ScannerShell usa ese null
// para decidir el default según tamaño de pantalla (colapsado en tablet/
// mobile) sin pisar una elección real del operador.
export const loadHistoryPanelCollapsed = () => {
  try {
    const raw = localStorage.getItem(HISTORY_PANEL_KEY);
    return raw === null ? null : raw === '1';
  } catch { return null; }
};

export const saveHistoryPanelCollapsed = (collapsed) => {
  try { localStorage.setItem(HISTORY_PANEL_KEY, collapsed ? '1' : '0'); } catch {}
};

// Último dispositivo de lectura (cámara/USB/manual) con el que se operó el
// escáner — el botón del navbar lo usa para abrir directo en ese modo en vez
// de siempre en cámara.
const LAST_INPUT_MODE_KEY = 'qr-scanner-last-input-mode';

export const loadLastInputMode = () => {
  try {
    const v = localStorage.getItem(LAST_INPUT_MODE_KEY);
    return v && STORAGE_KEYS[v] ? v : 'camera';
  } catch { return 'camera'; }
};

export const saveLastInputMode = (mode) => {
  try { localStorage.setItem(LAST_INPUT_MODE_KEY, mode); } catch {}
};
